import gql from 'graphql-tag'

export const Q_GET_OFFENSE_TYPES = gql`
  query {
    offenseTypes {
      id
      name
      start
      end
      unit
      description
      template
    }
  }
`

export const M_CREATE_OFFENSE_TYPE = gql`
  mutation($name: String!, $start: Int!, $end: Int!, $unit: TimeUnit!, $description: String, $template: String) {
    createOffenseType(
      name: $name,
      start: $start,
      end: $end,
      unit: $unit,
      description: $description,
      template: $template
    ) {
      id
      name
      start
      end
      unit
      description
      template
      }
  }
`

export const M_UPDATE_OFFENSE_TYPE = gql`
  mutation($id: Int!, $name: String, $start: Int, $end: Int, $unit: TimeUnit, $description: String, $template: String) {
    updateOffenseType(
      id: $id,
      name: $name,
      start: $start,
      end: $end,
      unit: $unit,
      description: $description,
      template: $template
    ) {
      id
      name
      start
      end
      unit
      description
      template
    }
  }
`

export const M_DELETE_OFFENSE_TYPE = gql`
  mutation($where: OffenseTypeWhereInput!) {
    deleteOffenseType(where: $where)
  }
` 